<app-picking-list-menu></app-picking-list-menu>

<div class="container-fluid">
    <div class="row">
        <div class="col">
<h4>Opret plukliste</h4>

<ng-container *ngFor="let log of log">
            <ngb-alert [dismissible]="false" [type]="'danger'" class="mt-3">
                {{ log.message }}
            </ngb-alert>
</ng-container>
            <form (submit)="addShipment()">
                <div class="d-flex my-3">
                    <input type="text" placeholder="Nota number" name="nota_number" class="form-control"
                           [(ngModel)]="search.nota_number" #yourInput
                           (blur)="onBlur($event)">
                    <button type="submit" class="btn btn-secondary">Scan</button>
                </div>
            </form>

            <div class="d-flex gap-2 align-items-center justify-content-between">

                <div *ngIf="shipmentPickingList && shipmentPickingList.shipments.length > 0">
                    <label class="form-label">Initialer</label>
                    <input type="text" placeholder="Initialer" name="initials" class="form-control"
                           [(ngModel)]="initials"
                           (click)="setStopBlur($event)"
                           (blur)="setStartBlur($event)"
                           autocomplete="off"
                           #initialsInput
                           (keydown.enter)="initialsInput.blur()"
                    >
                </div>

                <button (click)="createShipmentPickingList()"
                        *ngIf="shipmentPickingList && shipmentPickingList.shipments.length > 0"
                        [disabled]="!initials"
                        class="btn btn-primary my-3 d-flex flex-column">Print plukliste
                    <img *ngIf="imageBase64" style="background-color: white; padding: 5px"
                         [src]="imageBase64 ? ('data:image/png;base64,' +imageBase64) : ''"/>

                </button>
                <button (click)="resetState()" *ngIf="shipmentPickingList && shipmentPickingList.shipments.length > 0"
                        class="btn btn-danger">Nulstil
                </button>
            </div>

            <app-spinner *ngIf="loading"></app-spinner>
            <div class="d-flex gap-2 align-items-center">
                <!--                <span class="badge bg-secondary h5">-->
                <!--                Antal ordrer: <strong>{{ shipmentPickingList.shipments.length }}</strong>-->
                <!--                </span>-->
                                <span class="badge bg-secondary h5">
                                    Antal linjer: <strong>{{totalLines}}</strong>
                                </span>
<!--                <span class="badge bg-secondary h5">-->
<!--                    Antal produkter: <strong>{{ totalQt }}</strong>-->
<!--                </span>-->
            </div>
            <table class="mt-3 table table-striped table-bordered" *ngIf="shipmentPickingList && shipmentPickingList.shipments.length > 0">
                <thead>
                <tr>
                    <th>Nota number</th>
                    <th>Adresse</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let shipment of shipmentPickingList.shipments">
                    <td>
                        {{ shipment.nota_number }}
                    </td>
                    <td>
                        <app-shipment-address [address]="shipment.shipment_address"
                                             [oneLine]="true"></app-shipment-address>

                    </td>
                    <td>
                        <button (click)="removeShipment(shipment)" class="btn btn-danger btn-sm">Fjern</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
